import axios from 'axios';
import { IValueSource } from '@/shared/model/value-source.model';

const baseApiUrl = 'api/value_sources';

export default class ValueSourcesService {
  public find(id: number): Promise<IValueSource> {
    return new Promise<IValueSource>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          if (err.response.status === 404) {
            resolve(null);
          } else {
            reject(err);
          }
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(notaryId: number, entity: IValueSource): Promise<IValueSource> {
    return new Promise<IValueSource>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${notaryId}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public create(entity: IValueSource): Promise<IValueSource> {
    return new Promise<IValueSource>((resolve, reject) => {
      axios
        .post(baseApiUrl, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
